import config from 'constants/config'
import loadScript from 'lib/window/loadScript'

export const APPLE_SDK_SRC = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'

let readyPromise: Promise<void> | undefined

export function isAppleSdkReady(): boolean {
  // `window` is unbound during SSR. Optional chaining does not catch that, and
  // this runs from AppleLoginButton's useState initialiser.
  return typeof window !== 'undefined' && Boolean(window.AppleID?.auth)
}

export function ensureAppleSdk(): Promise<void> {
  if (isAppleSdkReady()) {
    return Promise.resolve()
  }

  if (readyPromise) {
    return readyPromise
  }

  readyPromise = loadScript(APPLE_SDK_SRC).then(() => {
    if (!isAppleSdkReady()) {
      readyPromise = undefined
      throw new Error('Apple SDK failed to load')
    }
  }).catch((error) => {
    readyPromise = undefined
    throw error
  })

  return readyPromise
}

export function preloadAppleSdk() {
  if (!config.APPLE_APP_ID) {
    return
  }

  ensureAppleSdk().catch(() => {})
}

export function resetAppleSdk() {
  readyPromise = undefined
}
